import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import TextInput from './TextInput';

/*
"address":{"id":null,"street1":"Puursesteenweg","street2":"","number":"390c","box":"","zipCode":"2880","city":"Bornem","region":null,"country":"BE"}
*/

export default class AddressInput extends Component {
  state = {
    showForm: false,
  };
  componentName = 'AddressInput';
  static propTypes = {};
  static defaultProps = {};

  handleFocus = () => {
    this.setState(state => ({
      ...state,
      showForm: true,
    }));
    // console.log('Component Name:', this.componentName, this);
  };

  handleBlur = () => {
    // console.log('Component Name:', this.componentName, this);
  };

  render() {
    const { showForm } = this.state;
    const asLabel = !showForm;
    return (
      <div>
        <div style={{ float: 'left', width: '60%' }}>
          <TextInput
            asLabel={asLabel}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            placeholder="Street 1"
          />
        </div>
        <div style={{ float: 'left', width: '18%', marginLeft: '2%' }}>
          <TextInput
            asLabel={asLabel}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            placeholder="No."
          />
        </div>
        <div style={{ float: 'left', width: '18%', marginLeft: '2%' }}>
          <TextInput
            asLabel={asLabel}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            placeholder="Bus"
          />
        </div>
        <div style={{ clear: 'both', width: '100%' }}>
          <TextInput
            asLabel={asLabel}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            placeholder="Street 2"
          />
        </div>
        <div style={{ float: 'left', width: '40%' }}>
          <TextInput
            asLabel={asLabel}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            placeholder="Postalcode"
          />
        </div>
        <div style={{ float: 'left', width: '58%', marginLeft: '2%' }}>
          <TextInput
            asLabel={asLabel}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            placeholder="Municipaly"
          />
        </div>
        <div style={{ clear: 'both' }}>
          <TextInput
            asLabel={asLabel}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            placeholder="Country"
          />
        </div>
      </div>
    );
  }
}
